<template>
    <div v-if="remark_num > 0">
        <el-popover
                placement="left"
                width="400"
                trigger="hover">
            <el-timeline>
                <el-timeline-item
                        v-for="(remark, index) in remarks"
                        :key="index"
                        :timestamp="remark.created_time">
                    <span>{{remark.created_user.username}}</span>
                    <el-divider direction="vertical"></el-divider>
                    <span>{{remark.remark}}</span>
                </el-timeline-item>
            </el-timeline>
            <el-badge slot="reference" style="margin:10px 0" :value="remark_num" class="item">
                <el-tag size="small" type="danger">备注</el-tag>
            </el-badge>
        </el-popover>
    </div>
</template>

<script>
    export default {
        name: "RemarkCol",
        props: {order: Object},
        computed: {
            remarks() {
                let _remarks = [];
                for (let i = 0; i < this.order.orderremark_set.length; i++) {
                    if (!this.order.orderremark_set[i].is_system) {
                        _remarks.push(this.order.orderremark_set[i])
                    }
                }
                return _remarks
            },
            remark_num() {
                let _num = 0;
                for (let i = 0; i < this.order.orderremark_set.length; i++) {
                    if (!this.order.orderremark_set[i].is_system) {
                        _num += 1
                    }
                }
                return _num
            }
        },
    }
</script>

<style scoped>

</style>